<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Marvin Kistler wrote <em>The Stranger Within</em>, published in 1995, about the two halves of the brain and how they function and relate to everyday life. In 2008, he wrote <em>The War Between the Ego and You; The Internal Battles for Control of the Self</em>.</p>
<p>He has a B.S. degree in education from Miami University in Oxford, Ohio; a B.S. degree in electrical engineering from South Florida University; one year of graduate school at the University of Mississipi in psychology and a Silver Life Master at duplicate bridge. He also dabbles in stand-up comedy at a local comedy club.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?64fec5cc